export const reportColumnsByType = {
  'country-wise-clients': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Phone Primary', keys: ['Phone_Primary'] },
    { label: 'Email Primary', keys: ['Email_Primary'] },
    { label: 'Country', keys: ['Country'] },
    { label: 'Visa Type', keys: ['Visa_Type'] },
    { label: 'Client Status', keys: ['Client_Status'] },
    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    { label: 'Process Type', keys: ['Process_Type'] },
    { label: 'Created Date', keys: ['Created_Date'] },
    { label: 'Updated Date', keys: ['Updated_Date'] },
  ],
  'country-wise-applications': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Client Mobile', keys: ['Client_Mobile', 'Phone_Primary'] },
    { label: 'Client Email', keys: ['Client_Email', 'Email_Primary'] },
    { label: 'Country', keys: ['Country'] },
    { label: 'Visa Type', keys: ['Visa_Type'] },
    { label: 'Submission Date', keys: ['Submission_Date'] },
    { label: 'Decision Date', keys: ['Decision_Date'] },
    {
      label: 'Decision Status',
      keys: ['Decision_Status', 'Case_Status', 'Client_Status'],
    },
    { label: 'Case Status', keys: ['Case_Status'] },
    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    {
      label: 'Multi Assigned Agents',
      keys: ['Multi_Assigned_Agents', 'Assigned_Agents_Name'],
    },
    { label: 'Process Type', keys: ['Process_Type'] },
    {
      label: 'Biometric Appointment Date',
      keys: ['Biometric_Appointment_Date'],
    },
    {
      label: 'Biometric Appointment City',
      keys: ['Biometric_Appointment_City', 'Biometric_Appointment City'],
    },
    { label: 'Visa Expiry Date', keys: ['Visa_Expiry_Date'] },
    { label: 'University Name', keys: ['University_Name'] },
    { label: 'Created Date', keys: ['Application_Created_Date'] },
    { label: 'Updated Date', keys: ['Last_Updated_Date', 'Updated_Date'] },
  ],
  'status-wise-cases': [
    { label: 'Application ID', keys: ['Client_ID','Application_ID'] },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Country', keys: ['Country'] },
    { label: 'Visa Type', keys: ['Visa_Type'] },
    { label: 'Case Status', keys: ['Case_Status'] },
    { label: 'Created Date', keys: ['Created_Date'] },
    { label: 'Updated Date', keys: ['Updated_Date'] },
    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    {
      label: 'Multi_Assigned_Agents',
      keys: ['Multi_Assigned_Agents', 'Assigned_Agents_Name'],
    },
    { label: 'Process Type', keys: ['Process_Type'] },
    { label: 'Visa Expiry Date', keys: ['Visa_Expiry_Date'] },
    {
      label: 'Biometric Appointment Date',
      keys: ['Biometric_Appointment_Date'],
    },
    {
      label: 'Biometric Appointment City',
      keys: ['Biometric_Appointment_City', 'Biometric_Appointment City'],
    },
  ],
  'pending-documents': [
    { label: 'Application ID', keys: ['Client_ID','Application_ID'] },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Country', keys: ['Country'] },
    { label: 'Visa Type', keys: ['Visa_Type'] },
    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    { label: 'Process Type', keys: ['Process_Type'] },
  ],
  'fee-status': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },
    { label: 'Invoice ID', keys: ['Invoice_ID'] },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Fee Type', keys: ['Fee_Type'] },
    { label: 'Amount', keys: ['Amount'] },
    { label: 'Paid Amount', keys: ['Paid_Amount'] },
    { label: 'Balance', keys: ['Balance'] },
    { label: 'Currency', keys: ['Currency'] },
    { label: 'Payment Status', keys: ['Payment_Status'] },
    { label: 'Last Payment Date', keys: ['Last_Payment_Date'] },
    { label: 'Approved By', keys: ['Approved_By'] },
  ],
  'agent-performance': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },

    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Country', keys: ['Country'] },
    {
      label: 'Country_Interested',
      keys: ['Country_Interested', 'Country_of_Interest'],
    },
    { label: 'Visa_Type', keys: ['Visa_Type'] },
    { label: 'Client_Status', keys: ['Client_Status'] },
    { label: 'Process Type', keys: ['Process_Type'] },
    { label: 'Created_Date', keys: ['Created_Date'] },
    { label: 'Updated_Date', keys: ['Updated_Date'] },
  ],
  'multi-assigned-cases': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },

    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Country', keys: ['Country'] },
    {
      label: 'Country of Interest',
      keys: ['Country_of_Interest', 'Country_Interested'],
    },
    { label: 'Case  Status', keys: ['Case_Status'] },
    {
      label: 'Assigned Agents Name',
      keys: ['Assigned_Agents_Name', 'Multi_Assigned_Agents'],
    },
    { label: 'Assigned Date', keys: ['Assigned_Date'] },
    { label: 'Assigned By', keys: ['Assigned_By'] },
  ],
  'visa-compliance': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },

    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Passport No', keys: ['Passport_No', 'Passport_Number'] },
    { label: 'Phone Primary', keys: ['Phone_Primary'] },
    { label: 'Email Primary', keys: ['Email_Primary'] },
    { label: 'Country', keys: ['Country'] },
    { label: 'Visa Type', keys: ['Visa_Type'] },
    { label: 'Visa Expiry Date', keys: ['Visa_Expiry_Date'] },
    { label: 'Days To Expiry', keys: ['Days_To_Expiry'] },
    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    { label: 'Process Type', keys: ['Process_Type'] },
    { label: 'Status', keys: ['Status', 'Case_Status', 'Client_Status'] },
  ],
  'biometric-schedule': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },

    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Country', keys: ['Country'] },
    {
      label: 'Country of Interest',
      keys: ['Country_of_Interest', 'Country_Interested'],
    },
    { label: 'Visa Type', keys: ['Visa_Type'] },
    {
      label: 'Biometric Appointment Date',
      keys: ['Biometric_Appointment_Date'],
    },
    {
      label: 'Biometric Appointment City',
      keys: ['Biometric_Appointment_City', 'Biometric_Appointment City'],
    },
    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    { label: 'Case Status', keys: ['Case_Status'] },
    { label: 'Process Type', keys: ['Process_Type'] },
  ],
  'category-wise-clients': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },

    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Process Type', keys: ['Process_Type'] },
    { label: 'Country', keys: ['Country'] },
    { label: 'Visa Type', keys: ['Visa_Type'] },
    { label: 'Client Status', keys: ['Client_Status'] },
    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    { label: 'Created Date', keys: ['Created_Date'] },
  ],
  'agent-reference-clients': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },

    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Agent Reference', keys: ['Agent_Reference', 'Reference'] },
    { label: 'Assigned Agent Name', keys: ['Assigned_Agent_Name'] },
    { label: 'Country', keys: ['Country'] },
    {
      label: 'Country of Interest',
      keys: ['Country_of_Interest', 'Country_Interested'],
    },
    { label: 'Visa Type', keys: ['Visa_Type'] },
    { label: 'Created Date', keys: ['Created_Date'] },
  ],
  'protected-documents': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },

    {
      label: 'Uploaded Date/Time',
      keys: ['Uploaded_DateTime', 'Created_Date'],
    },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Document Category', keys: ['Document_Category'] },
    { label: 'Subfolder Path', keys: ['Subfolder_Path'] },
    { label: 'Original File Name', keys: ['Original_File_Name'] },
    { label: 'Uploaded By Agent Name', keys: ['Uploaded_By_Agent_Name'] },
    { label: 'Is Protected', keys: ['Is_Protected'] },
    { label: 'Visible To Client', keys: ['Visible_To_Client'] },
  ],
  'duplicate-clients': [
    { label: 'Match Type', keys: ['Match_Type'] },
    { label: 'Match Value', keys: ['Match_Value'] },
    { label: 'Client Name 1', keys: ['Client_Name_1'] },
    { label: 'Client Name 2', keys: ['Client_Name_2'] },
    { label: 'Client ID 1', keys: ['Client_ID_1','Application_ID_1'] },
    { label: 'Client ID 2', keys: ['Client_ID_2','Application_ID_2'] },


  ],
  'deleted-cases': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },

    { label: 'Deleted DateTime', keys: ['Deleted_DateTime'] },
    { label: 'Deleted By Name', keys: ['Deleted_By_Name'] },
    { label: 'Deleted By Role', keys: ['Deleted_By_Role'] },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Country', keys: ['Country'] },
    {
      label: 'Country of Interest',
      keys: ['Country_of_Interest', 'Country_Interested'],
    },
    { label: 'Email', keys: ['Email', 'Client_Email', 'Email_Primary'] },
    {
      label: 'Mobile No',
      keys: ['Mobile_No', 'Mobile No', 'Client_Mobile', 'Phone_Primary'],
    },
    { label: 'Reference', keys: ['Reference', 'Agent_Reference'] },
    { label: 'Reason', keys: ['Reason'] },
  ],
  'admin-role-changes': [
    { label: 'Changed DateTime', keys: ['Changed_DateTime'] },
    { label: 'Changed By Admin Name', keys: ['Changed_By_Admin_Name'] },
    { label: 'Target User Name', keys: ['Target_User_Name'] },
    { label: 'Old Role', keys: ['Old_Role'] },
    { label: 'New Role', keys: ['New_Role'] },
    { label: 'Reason', keys: ['Reason'] },
  ],
  'pending-payment-approval': [
    { label: 'Client ID', keys: ['Client_ID','Application_ID'] },
    { label: 'Invoice ID', keys: ['Invoice_ID'] },
    { label: 'Client Name', keys: ['Client_Name'] },
    { label: 'Fee Type', keys: ['Fee_Type'] },
    { label: 'Amount', keys: ['Amount'] },
    { label: 'Paid Amount', keys: ['Paid_Amount'] },
    { label: 'Balance', keys: ['Balance'] },
    { label: 'Currency', keys: ['Currency'] },
    { label: 'Payment Status', keys: ['Payment_Status'] },
    { label: 'Last Payment Date', keys: ['Last_Payment_Date'] },
    { label: 'Approved By', keys: ['Approved_By'] },
  ],
};
export const reportConfig = [
  {
    reportType: 'country-wise-clients',
    label: 'Country-wise Client',
    filters: ['countries'],
  },
  {
    reportType: 'country-wise-applications',
    label: 'Country-wise Applications',
    filters: ['countries', 'status'],
  },
  {
    reportType: 'status-wise-cases',
    label: 'Status-wise Clients/Cases',
    filters: ['status'],
  },
  {
    reportType: 'pending-documents',
    label: 'Pending Documents',
    filters: ['countries'],
  },
  {
    reportType: 'fee-status',
    label: 'Pending Payments / Fee Status',
    filters: ['countries'],
  },
  {
    reportType: 'agent-performance',
    label: 'Agent / Team Performance Report',
    filters: ['agents', 'countries'],
  },
  {
    reportType: 'multi-assigned-cases',
    label: 'Multi-Assigned Cases',
    filters: ['agents', 'countries'],
  },
  {
    reportType: 'visa-compliance',
    label: 'Visa & Compliance Reports',
    filters: ['countries', 'days'],
  },
  {
    reportType: 'biometric-schedule',
    label: 'Biometric Appointment Schedule',
    filters: ['countries', 'biometricFromDate', 'biometricToDate'],
  },
  {
    reportType: 'category-wise-clients',
    label: 'Category-Wise Clients',
    filters: ['countries', 'visaCategory'],
  },
  {
    reportType: 'agent-reference-clients',
    label: 'Agent Reference-wise Clients',
    filters: ['countries'],
  },
  {
    reportType: 'protected-documents',
    label: 'Agent-Uploaded Protected Documents',
    filters: ['countries'],
  },
  {
    reportType: 'duplicate-clients',
    label: 'Duplicate Clients',
    filters: ['countries', 'matchField'],
    matchFieldOptions: ['passport', 'phone', 'email'],
  },
  {
    reportType: 'deleted-cases',
    label: 'Deleted Cases Report',
    filters: ['countries'],
  },
  {
    reportType: 'admin-role-changes',
    label: 'Admin Role Changes',
    filters: [],
  },
  {
    reportType: 'pending-payment-approval',
    label: 'Pending Payment Approval',
    filters: ['countries'],
  },
  {
    reportType: 'raw-application-data',
    label: 'Raw Application Data',
    filters: [],
  },
];